import {
  Field,
  ImageField,
  LinkField,
  RichTextField,
  TextField,
} from '@sitecore-jss/sitecore-jss-nextjs';

import * as icons from '@gn-audio/icons';
import { ButtonVariantType } from '@gn-audio/jss-components';

export type FirstButtonSettings = {
  firstButtonLink: LinkField;
  firstButtonText: TextField;
  firstButtonVariant: Field<ButtonVariantType>;
  firstButtonAriaLabel?: Field<string>;
};

export type SecondButtonSettings = {
  secondButtonLink: LinkField;
  secondButtonText: TextField;
  secondButtonVariant: Field<ButtonVariantType>;
  secondButtonAriaLabel?: Field<string>;
};

export type DualColumnPromoItem = {
  id: string;
  image: ImageField;
  headline: RichTextField;
  description: RichTextField;
  firstButtonIcon?: Field<keyof typeof icons>;
  secondButtonIcon?: Field<keyof typeof icons>;
  firstCtaButtonTrackingItemName?: Field<string>;
  secondCtaButtonTrackingItemName?: Field<string>;
} & FirstButtonSettings &
  SecondButtonSettings;
